import { PageHeader, Page, PageContent, Box, Text} from 'grommet';
import { ValueStreamsGrid } from './ValueStreamsGrid';
//import { useHeaderHeight } from '../../utils/HeaderHeightContext';

export const ValueStreamsHome = () => {
  //const { headerHeight } = useHeaderHeight(); // Get headerHeight from context
  return (
    <Page flex="grow"
          background="background">

      <Box background="url('/images/home-banner.png')" height="140px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader pad={{ bottom: '10px' }} 
            title={<Text color="black" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>HPE Value Stream</Text>} 
            subtitle={'Driving modern E2E outcome and experience focus.'}
            style={{ color: 'black' }}
            size='medium'/>
        </Box>                  
      </Box>

      <PageContent flex="grow" width="80%">
        <ValueStreamsGrid isVerticalGrid = {true} isGridExpanded = {false} />
      </PageContent>

    </Page>
  );
};